import { render, staticRenderFns } from "./OpenAIMessageAssistant.vue?vue&type=template&id=6363cd58&scoped=true&"
import script from "./OpenAIMessageAssistant.vue?vue&type=script&lang=js&"
export * from "./OpenAIMessageAssistant.vue?vue&type=script&lang=js&"
import style0 from "./OpenAIMessageAssistant.vue?vue&type=style&index=0&id=6363cd58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6363cd58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VChip,VDivider,VIcon,VSpacer,VTextField,VToolbar,VToolbarTitle,VTooltip})
